import { createAction, handleActions } from 'redux-actions';

const setFilters = createAction("SCREENS/PROJECTS/SET_FILTERS");

const defaultState = {
  status_key: 2,
  quick_filter: "",
  phase_key: [],
  client_id: [],
  contracts_manager: [],
  supervisor_id: [],
  order_ack_sent: undefined,
  project_info_sent: undefined,
  no_valuation_this_month: false,
  no_start_handover_date: false,
};

const reducer = handleActions(
  {
    [setFilters]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setFilters, reducer };
